import { Flex, Tooltip, Typography } from "antd";
import { observer } from "mobx-react-lite";
import { useStores } from "stores";
import { ReactComponent as EditIcon } from "images/editIcon.svg";
import { EditCustomFeeModal } from "./EditCustomFeeModal";
import { MODE_TYPE } from "interfaces";
import { QuestionCircleOutlined } from "@ant-design/icons";

interface IProps {
  text?: string;
  mode: MODE_TYPE;
}

export const EditCustomFeeBtn = observer((props: IProps) => {
  const { actionModals } = useStores();
  const { text, mode } = props;
  const title =
    mode === MODE_TYPE.CUSTOMER
      ? "Редактирование дополнительной комиссии УВЭД"
      : "Редактирование дополнительной комиссии ПЛ";

  const editFeeHandler = () => {
    actionModals.open(() => <EditCustomFeeModal mode={mode} />, {
      width: "650px",
      noValidation: true,
      isOverlayClose: false,
      title: title,
      onApply: () => {
        return Promise.resolve();
      },
    });
  };
  return (
    <Flex gap="small" align="center">
      {text ?? `${0 * 100} %`}
      <EditIcon className="cursor-pointer" onClick={editFeeHandler} />
    </Flex>
  );
});
